module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/custom-grid-01-470ee999a32ff80aa89ff95f872facaa.jpg";